/**
* @name APP u-Planning
* @autor over.martinez@u-planner.com
* @description
* Descripcion del controlador
* @controller
* # name: warningApprovalCtrl
* # alias: warningCtrl
*/

export default class warningApprovalCtrl {

	constructor($scope, $state, $stateParams, ngNotify, $timeout, UserInfoConstant, WorkPlanSrv, WorkPlanModalSrv, $mdDialog, ReviewSrv, GlobalConfig, Validations, $cookies) {
		this.$scope = $scope
		this.$state = $state
		this.$timeout = $timeout
		this.ngNotify = ngNotify
		this.$stateParams = $stateParams
		this.WorkPlanSrv = WorkPlanSrv
		this.WorkPlanModalSrv = WorkPlanModalSrv
		this.$mdDialog = $mdDialog
		this.userinfo = null
		this.$scope.UserInfoConstant = UserInfoConstant

		const sharedVar = WorkPlanModalSrv.getVariable() || {}
		const currentStage = sharedVar.currentStage

		this.inReview = Validations.inReview(currentStage)
		this.inReviewExecution = Validations.inReviewExecution(currentStage)
		this.pendingBreakdown = null
		this.pendingBreakdownLoaded = false
		this.hasPendingOther = () => !!(this.pendingBreakdown && this.pendingBreakdown.other && this.pendingBreakdown.other.length > 0)
		this.assignedAllApproved = () => !!(this.pendingBreakdown && this.pendingBreakdown.assigned && this.pendingBreakdown.assigned.pending === 0)

		if ((this.inReview || this.inReviewExecution) && sharedVar.teacherId && sharedVar.workplanId) {
			const currentUser = $cookies.getObject('currentUser')
			const currentRoleId = +$cookies.get('hasRoleId')
			const stageId = this.inReview
				? GlobalConfig.workplanIdStages.review
				: GlobalConfig.workplanIdStages.reviewExecution

			ReviewSrv.getPendingActivitiesBySubmodule.post({
				teacherId  : sharedVar.teacherId,
				workplanId : sharedVar.workplanId,
				stageId    : stageId,
				evaluatorId: currentUser.id,
				roleId     : currentRoleId,
			}).$promise.then((dataReturn) => {
				if (dataReturn && dataReturn.status) {
					this.pendingBreakdown = dataReturn.data
				}
			}).finally(() => {
				this.pendingBreakdownLoaded = true
			})
		} else {
			this.pendingBreakdownLoaded = true
		}
	}

	close(response) {
		return this.$mdDialog.hide(response)
	}

}

warningApprovalCtrl.$inject = [ '$scope', '$state', '$stateParams', 'ngNotify', '$timeout', 'UserInfoConstant', 'WorkPlanSrv', 'WorkPlanModalSrv', '$mdDialog', 'ReviewSrv', 'GlobalConfig', 'Validations', '$cookies' ]



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/partials/review/summary/modals/warningApprovalCtrl.js